import { useEffect } from 'react';
import { Backdrop, CircularProgress, Paper, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  container: {
    position: 'relative',
    zIndex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.spacing(2),
    top: '30vh',
    left: '40%',
    width: '20%',
    textAlign: 'center',
    [theme.breakpoints.down('sm')]: {
      top: '30vh',
      left: '25%',
      width: '50%',
    },
  },
}));

export function QuickStartSpinner({ building = false }: { building?: boolean }) {
  const { classes } = useStyles();

  useEffect(() => {
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = prev;
    };
  }, []);

  return (
    <>
      <Backdrop open={true} sx={{ backgroundColor: 'rgba(0, 0, 0, 0.3)', position: 'fixed', zIndex: 1 }} />
      <Paper className={classes.container} elevation={3} sx={{ padding: 2 }}>
        <CircularProgress />
        <Typography variant='body1'>{`${building ? 'Setting up' : 'Loading'} your store...`}</Typography>
      </Paper>
    </>
  );
}
